import MyBusiness from '../components/Settings/MyBusiness'; // Assuming you have this component

export default function SettingsBusinessPage() {
  return (
    <>
      {/* <h2 className="text-2xl font-semibold mb-4 text-blue-600">My business</h2> */}
      <MyBusiness />
    </>
  );
}
